import { sanitizeHtml } from './sanitizeHtml'

function hasOuterParens(str) {
  return /^\((.+)\)$/.test(str)
}

function outerParensWrapWholeString(str) {
  let depth = 0

  for (let i = 0; i < str.length; i += 1) {
    const char = str.charAt(i)

    if (char === '(') depth += 1
    if (char === ')') depth -= 1

    if (depth === 0 && i < str.length - 1) {
      return false
    }
  }

  return true
}

function removeOuterParens(text) {
  let str = text

  while (hasOuterParens(str) && outerParensWrapWholeString(str)) {
    str = str.slice(1, -1)
  }

  return str
}

function cleanParts(expr) {
  return expr.split(/\bOR\b/).map(part => removeOuterParens(part.trim())).join(' OR ')
}

function splitByTopLevelAND(expr) {
  const parts = []
  let bracketCount = 0
  let start = 0
  const separator = ' AND '

  let i = 0
  while (i < expr.length) {
    const char = expr.charAt(i)

    if (char === '(') bracketCount += 1
    else if (char === ')') bracketCount -= 1

    if (bracketCount === 0 && expr.slice(i, i + separator.length) === separator) {
      parts.push(expr.slice(start, i).trim())
      start = i + separator.length
      i = start
    }
    else {
      i += 1
    }
  }

  parts.push(expr.slice(start).trim())
  return parts
}

function highlightOR(expr) {
  return expr.replace(/\bOR\b/g, '<span class="or-divider">OR</span>')
}

export function transformExpression(input) {
  let index = 0
  const result = []

  const cleanedInput = removeOuterParens(input)
  const expressions = splitByTopLevelAND(cleanedInput)

  for (const exp of expressions) {
    const cleaned = cleanParts(removeOuterParens(exp))
    const highlighted = highlightOR(cleaned)
    index += 1
    result.push(
      `<div class="line">
        <span class="number">
            ${ index }
        </span>
        <span class="content">
            + ${ highlighted }
        </span>
      </div>`
    )
  }

  return sanitizeHtml(result.join('\n'))
}

export function transformSimilarResults(input) {
  if (!input) return { expressions: [], formattedExplanation: '' }

  const result = []
  const expressions = []

  const cleanedInput = removeOuterParens(input)
  const expressionParts = splitByTopLevelAND(cleanedInput)

  for (const exp of expressionParts) {
    const cleaned = cleanParts(removeOuterParens(exp))
    expressions.push(cleaned)
    const highlighted = highlightOR(cleaned)
    result.push(
      `<div class="line">
        <span class="content">
            + ${ highlighted }
        </span>
      </div>`
    )
  }

  return {
    expressions,
    formattedExplanation: sanitizeHtml(result.join('\n'))
  }
}
